module.exports = __webpack_public_path__ + "static/media/gc-bus-mad.ecfdf126.png";